// Applies a resolved claim-window winner to state — split out of
// `BotDriver.ts` for the 200-line cap. Pure: given the live state and the
// full set of voiced claims (bot + local), returns the resulting state, or
// `null` when the phase has already moved on (the caller's guard).

import {
  claimChi,
  claimPung,
  declareRon,
  passClaims,
  type MahjongState,
} from '../game/GameState.js';
import { resolveClaimPriority, type Claim } from '../game/Claims.js';

/** Picks the highest-priority claim among `claims` (Ron > Pung > Chi, ties by
 *  seat distance) and applies it to `state` — or passes the discard through
 *  untouched if nobody claimed it. */
export function resolveClaims(state: MahjongState, claims: readonly Claim[]): MahjongState | null {
  if (state.phase !== 'claim-window' || state.lastDiscard === null) return null;
  const winner = resolveClaimPriority(claims, state.lastDiscard.from);
  return applyWinner(state, winner);
}

function applyWinner(state: MahjongState, winner: Claim | null): MahjongState {
  if (winner === null) return passClaims(state);
  switch (winner.type) {
    case 'ron':
      return declareRon(state, winner.seat);
    case 'pung':
      return claimPung(state, winner.seat);
    case 'chi':
      return claimChi(state, winner.seat, winner.option);
  }
}
